import { Button } from '@tempo-io/sui-button';

import { useSwimlaneEventPublisher } from '../../api/useSwimlaneEventPublisher';

import { ItemsFilteredIcon } from './icons/ItemsFilteredIcon';
import {
  FooterTypography,
  StyledBox,
  StyledDiv,
  StyledDivider,
  SubtitleTypography,
  TitleTypography,
} from './StyledComponents';

export function AllItemsFiltered() {
  const publishEvent = useSwimlaneEventPublisher();

  return (
    <StyledDiv>
      <StyledBox>
        <ItemsFilteredIcon />
        <TitleTypography>No Items Match Filters</TitleTypography>
        <SubtitleTypography>
          Filters on this view are hiding all items. Try a less specific Filter
        </SubtitleTypography>
        <Button onClick={() => publishEvent('emptyStateButtonClicked', { action: 'edit-filters' })}>
          Edit Filters
        </Button>
        <StyledDivider variant="middle" />
        <FooterTypography>
          Need more guidance?
          <br />
          <a
            href="https://help.tempo.io/roadmaps/latest/working-with-filters"
            target="_blank"
            rel="noreferrer"
          >
            Visit the Tempo Help Center
          </a>
        </FooterTypography>
      </StyledBox>
    </StyledDiv>
  );
}
